var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"origin-option"},[_vm._v("\n  "+_vm._s(_vm.option.title)+"\n  "),(_vm.option.is_custom)?_c('b-tag',{style:({ backgroundColor: '#2bd5c4' }),attrs:{"type":"is-success"}},[_vm._v("\n    Personalizado\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }